export const zhTw = {
  // Common
  "common.back": "返回",
  "common.cancel": "取消",
  "common.noItems": "無項目",
  "common.loading": "加載中...",
  
  // Header
  "nav.features": "功能特色",
  "nav.howItWorks": "運作原理",
  "nav.pricing": "價格方案",
  "nav.faq": "常見問題",
  "nav.testimonials": "展示牆",
  "nav.contact": "聯絡我們",
  "button.getStarted": "立即開始",
  "button.loading": "加載中...",

  // Auth related
  "auth.signIn": "登入",
  "auth.redirecting": "正在跳轉...",
  "auth.continueWithGoogle": "使用谷歌帳號登入",
  "auth.continueWithGithub": "使用GitHub帳號登入",
  "auth.or": "或者",
  "auth.consent.prefix": "繼續即表示您同意我們的",
  "auth.consent.terms": "服務條款",
  "auth.consent.and": "和",
  "auth.consent.privacy": "隱私政策",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "AI智慧溝通助手",
  "hero.subtitle": "通過智慧、情境感知的回復轉變您的對話管道，幫助您在任何情况下更有效地溝通。",
  "hero.cta.primary": "免費試用",
  "hero.cta.secondary": "觀看演示",
  "hero.cta.tryNow": "免費開始",
  "hero.cta.learnMore": "了解更多",
  "hero.cta.getStarted": "免費開始",
  "hero.preview.primary": "優化語調",
  "hero.preview.secondary": "翻譯",
  "hero.preview.tone": "友善",
  "hero.preview.target": "客戶",
  "hero.hook": "加入成千上萬每天改善溝通的用戶。",
  "hero.headline": "AI智慧溝通助手",
  "hero.subheadline": "將原始想法在幾秒內轉化為精緻、情境感知的回覆。",
  
  // Stats
  "stats.users": "用戶",
  "stats.replies": "回覆",
  "stats.languages": "語言",

  // Main Title
  "main.title": "將每一次回覆都轉化為機會",

  // Footer Section - 新增
  "footer.company": "公司",
  "footer.product": "產品",
  "footer.support": "支援",
  "footer.legal": "法律條款",
  "footer.contactSupport": "聯絡支援",
  "footer.helpCenter": "幫助中心",
  "footer.apiDocs": "API文檔",
  "footer.statusPage": "服務狀態",
  "footer.privacyPolicy": "隱私政策",
  "footer.termsOfService": "服務條款",
  "footer.cookiePolicy": "Cookie政策",
  "footer.refundPolicy": "退款政策",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "客戶支援",

  "features.badge": "強大功能",
  "features.title": "更好溝通所需的一切",
  "features.subtitle": "全面的工具設計，讓每一次對話都更有效、更專業。",
  "features.scenario.title": "場景模板",
  "features.scenario.description": "為職場、個人、學術和專業溝通預建的模板。",
  "features.custom.title": "自定義輸入",
  "features.custom.description": "貼上任何訊息或內容，獲得符合上下文的適當回覆。",
  "features.instant.title": "回復時間縮短90%",
  "features.instant.description": "在幾秒內獲得AI精心製作的回覆。無需等待，立即獲得結果。",
  "features.copy.title": "一鍵複製和分享",
  "features.copy.description": "即時複製回覆或直接從平台分享。",
  "howItWorks.badge": "運作原理",
  "howItWorks.title": "三個簡單步驟實現更好溝通",
  "howItWorks.subtitle": "我們的簡化流程讓您輕鬆為任何情況生成專業回覆。",
  "howItWorks.step1.title": "選擇場景",
  "howItWorks.step1.description": "選擇最適合您需求的溝通場景。",
  "howItWorks.step2.title": "貼上內容",
  "howItWorks.step2.description": "添加您需要回覆的訊息或內容。",
  "howItWorks.step3.title": "獲得AI回覆",
  "howItWorks.step3.description": "在幾秒鐘內收到專業的、符合上下文的回覆。",
  "pricing.title": "定價",
  "pricing.subtitle": "選擇適合您溝通需求的方案",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/月",
  "pricing.free.description": "非常適合試用我們的服務",
  "pricing.pro.description": "專業人士和頻繁用戶的理想選擇",
  "pricing.business.description": "適合團隊和組織",
  "pricing.popular": "最受歡迎",
  "pricing.free.feature1": "每月10次回覆",
  "pricing.free.feature2": "基礎場景",
  "pricing.free.feature3": "定義和使用模版",
  "pricing.free.feature4": "歷史回覆記錄",
  "pricing.pro.feature1": "每月200次回覆",
  "pricing.pro.feature2": "基礎+自定義場景",
  "pricing.pro.feature3": "定義和使用模版",
  "pricing.pro.feature4": "歷史回覆記錄",
  "pricing.pro.feature5": "高級自定義",
  "pricing.business.feature1": "無限回覆",
  "pricing.business.feature2": "團隊協作",
  "pricing.business.feature3": "基礎+自定義場景",
  "pricing.business.feature4": "定義和使用模版",
  "pricing.business.feature5": "歷史回覆記錄",
  "pricing.business.feature6": "高級自定義",
  "pricing.cta.trial": "開始免費試用",
  "pricing.cta.subscribe": "立即訂閱",
  "pricing.cta.contact": "聯絡銷售",
  "pricing.cta.current": "當前計劃",
  "pricing.currentPlan": "當前計劃:",
  "pricing.endDate": "當前計劃終止日期:",
  "pricing.autoRenewalDate": "當前計劃自動續費日期:",
  "pricing.answersLeft": "剩餘回覆:",
  "pricing.planName.free": "Free 計劃",
  "pricing.planName.proMonthly": "Pro 計劃-月付",
  "pricing.planName.proYearly": "Pro 計劃-年付",
  "pricing.planName.maxMonthly": "Enterprise 計劃-月付",
  "pricing.planName.maxYearly": "Enterprise 計劃-年付",
  "pricing.autoRenews": "您的回覆次數將於以下日期自動續期:",
  "pricing.needMore": "需要更多回覆?",
  "pricing.upgradeBelow": "請在下方升級您的計劃",
  "pricing.doNotRollOver": "未用回覆不會結轉至下一個週期",
  "pricing.willCancelOn": "將於以下日期取消:",
  "pricing.downgradeScheduled": "已安排降級。將切換至",
  "pricing.on": "於:",
  "pricing.upgradeImmediateTitle": "計劃已升級",
  "pricing.upgradeImmediateDesc": "您的新計劃現已生效。",
  "pricing.downgradeScheduledTitle": "已安排降級",
  "pricing.downgradeScheduledDesc": "您的計劃將在下次續訂時更改。",
  "pricing.cancelScheduledTitle": "已安排取消",
  "pricing.cancelScheduledDesc": "您的計劃將在週期結束時終止。",
  "pricing.cancelResumedTitle": "已移除取消",
  "pricing.cancelResumedDesc": "您的訂閱將繼續續訂。",
  "pricing.cancelPendingDowngrade": "取消",
  "pricing.pendingDowngradeCanceledTitle": "已取消待處理的降級",
  "pricing.pendingDowngradeCanceledDesc": "您的計劃將保持不變。",
  "pricing.pendingDowngradeCancelFailedTitle": "取消失敗",
  "pricing.pendingDowngradeCancelFailedDesc": "無法取消待處理的降級。請重試。",
  "pricing.cancelPendingDowngradeProcessing": "處理中...",
  "pricing.scheduled": "已安排",
  "pricing.processing": "處理中...",
  "pricing.getMoreReplies": "獲取更多回覆",
  "pricing.oneTimeTitle": "為您的帳戶獲取更多回覆",
  "pricing.oneTimeAmountLabel": "金額 (USD)",
  "pricing.repliesUnit": "回覆",
  "pricing.oneTimeNotice": "您購買的回覆數量在當月週期內有效。使用時需要有效的付費訂閱，未使用的回覆不會結轉。",
  "pricing.cancel": "取消",
  "pricing.proceed": "繼續",
  "pricing.confirmUpgradeTitle": "確認升級",
  "pricing.confirmDowngradeTitle": "確認降級",
  "pricing.confirmUpgradeDesc": "您即將升級您的計劃。變更將立即生效，可能適用按比例計費（或信用額度）。",
  "pricing.confirmDowngradeDesc": "您即將安排降級。您目前的功能將保持到當前計費週期結束。",
  "pricing.downgradeEffectNote": "降級不會退還當前週期費用。",
  "pricing.downgradeApplyNextCycle": "新計劃將在續訂時自動開始。",
  "pricing.confirmCancel": "返回",
  "pricing.confirmProceedUpgrade": "立即升級",
  "pricing.confirmProceedDowngrade": "安排降級",

  // FAQ Section
  "faq.title": "常見問題",
  "faq.subtitle": "關於溝通制勝您需要了解的一切",
  "faq.q1": "支援哪些溝通場景？",
  "faq.a1": "我們支援職場溝通、人際關係、學術通信、客戶服務、銷售推廣等多種場景。我們的AI會根據每種情況所需的上下文和語調進行調整。",
  "faq.q2": "回覆生成速度有多快？",
  "faq.a2": "我們的AI在幾秒內生成回覆。我們在不影響品質的前提下優先考慮速度，確保您能立即獲得專業回覆。",
  "faq.q3": "我可以隨時取消訂閱嗎？",
  "faq.a3": "是的，您可以隨時取消訂閱。沒有長期承諾，您可以根據需要降級或升級您的方案。",
  "faq.q4": "我的資料安全和隱私有保障嗎？",
  "faq.a4": "是的，我們實施了全面的安全措施，包括加密、存取控制和定期安全審計。您的輸入內容和生成的回覆會作為用戶歷史記錄存儲，以啟用回覆查看和模板創建等功能。您可以隨時通過帳戶設定刪除歷史資料。",
  "faq.q5": "如果我的 Replies 數量不夠用怎麼辦？",
  "faq.a5": "Free 用戶的 Replies 用完後，需要等待下一個月週期自動刷新。升級為 Pro 後，如果 Replies 不夠用，可以單獨購買增加；購買增加的 Replies 僅在當月週期內有效。Enterprise 用戶擁有無限 Replies。",
  "faq.q6": "支援哪些語言？",
  "faq.a6": "目前我們支援英語，計劃擴展到西班牙語、法語、德語和其他主要語言。AI可以有效處理多語言溝通。",
  "testimonials.title": "展示牆",
  "testimonials.subtitle": "各類溝通公開示例，激發你的回復靈感",
  "testimonials.sarah.name": "莎拉·約翰遜",
  "testimonials.sarah.title": "行銷總監",
  "testimonials.sarah.quote": "溝通制勝改變了我處理客戶溝通的方式。回覆專業且每週為我節省數小時時間。",
  "testimonials.michael.name": "邁克爾·陳",
  "testimonials.michael.title": "銷售經理",
  "testimonials.michael.quote": "職場場景模板非常準確。自從使用這個工具以來，我的回覆率提高了40%。",
  "testimonials.emily.name": "艾米麗·羅德里格斯",
  "testimonials.emily.title": "客戶成功主管",
  "testimonials.emily.quote": "非常適合處理困難的客戶情況。AI完美理解上下文和語調。",
  "testimonials.more": "點擊畫廊探索完整展示",
  "interface.generating": "正在生成回覆...",
  "interface.generate": "生成AI回覆",
  "interface.processing": "正在處理...",
  "interface.advancedOptions": "高級選項",
  "interface.clearInput": "清除輸入",
  "interface.clearDescription": "清除描述",
  // Marquee / Logos
  "marquee.trusted": "合作/支持",
  "marquee.aria": "品牌標誌",

  // History and Showcase
  "history.shareToShowcase": "發佈到展示牆",
  "history.showcased": "已發佈",
  "history.shareConfirm": "確定將此資訊發佈到展示牆？此操作不可撤回，除非删除該資訊。",
  "history.sharedBy": "發佈者：",
  "interface.copy": "複製",
  "interface.share": "分享",
  "interface.shareResponse": "分享回覆",
  "interface.shareNative": "系統分享",
  "interface.shareEmail": "郵件",
  "interface.copyShareText": "複製帶連結",
  "interface.shareTextCopied": "回覆和連結已複製到剪貼板。",
  "interface.ready": "準備生成",
  "interface.enterMessage": "輸入您的訊息內容並選擇場景，開始使用AI驅動的回覆。",
  "interface.fast": "快速",
  "interface.accurate": "準確",
  "interface.professional": "專業",
  "interface.translation": "翻譯",
  "interface.responseDescription": "這裡有一個深思熟慮和專業的回覆，適合當前的上下文：",
  "interface.multipleOptions": "多個回覆選項：",
  "interface.option": "選項",
  "interface.noContent": "暫無內容",
  "placeholder.message": "貼上您要回覆的訊息、郵件內容或收到的文字...",

  "dropdown.useTemplates": "使用範本",
  "dropdown.scenario": "無場景",
  "dropdown.target": "無目標",
  "dropdown.tone": "無語氣",
  
  // Scenario Options
  "scenario.email": "郵件",
  "scenario.message": "訊息",
  "scenario.workplace": "職場",
  "scenario.school": "學校",
  "scenario.home": "家庭",
  "scenario.business": "商務",
  "scenario.academic": "學術",
  "scenario.social": "社交",
  "scenario.formal": "正式",
  "scenario.casual": "隨意",
  "scenario.professional": "專業",
  "scenario.personal": "個人",
  "scenario.customerService": "客戶服務",
  "scenario.interview": "面試",
  "scenario.presentation": "演示",
  
  // Target Options
  "target.lover": "戀人",
  "target.friend": "朋友",
  "target.boss": "老闆",
  "target.colleague": "同事",
  "target.classmate": "同學",
  "target.parents": "父母",
  "target.child": "孩子",
  "target.teacher": "老師",
  "target.student": "學生",
  "target.client": "客戶",
  "target.customer": "顧客",
  "target.stranger": "陌生人",
  "target.family": "家人",
  "target.sibling": "兄弟姐妹",
  "target.neighbor": "鄰居",
  "target.mentor": "導師",
  "target.supplier": "供應商",
  "target.serviceProvider": "服務提供商",
  "target.partner": "合作夥伴",
  "target.subordinate": "下屬",
  
  // Tone Options
  "tone.humorous": "幽默",
  "tone.serious": "嚴肅",
  "tone.happy": "開心",
  "tone.angry": "憤怒",
  "tone.mischievous": "調皮",
  "tone.polite": "禮貌",
  "tone.casual": "隨意",
  "tone.formal": "正式",
  "tone.friendly": "友好",
  "tone.confident": "自信",
  "tone.apologetic": "道歉",
  "tone.enthusiastic": "熱情",
  "status.copied": "已複製！",
  "status.copyDescription": "回覆已複製到剪貼簿。",
  "status.copyWithTranslationDescription": "回覆和翻譯已複製到剪貼簿。",
  "status.success": "回覆生成成功。",
  "status.successWithTranslation": "回覆生成成功，並帶有翻譯。",
  "status.successWithoutTranslation": "回覆生成成功。",
  "status.error": "生成失敗",
  "status.errorDescription": "生成回覆失敗。請重試。",
  "status.enterContent": "請輸入內容",
  "status.enterContentDescription": "添加您要回覆的訊息。",
  
  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "描述（選填）",
  "restriction.descriptionLabel": "描述 (僅限Pro / Enterprise訂閱者)",
  "restriction.proMaxOnly": "* 僅限Pro / Enterprise訂閱者",
  "restriction.desPrompt": "輸入上下文、背景資訊或具體要求，以協助產生更佳的回覆…",
  
  // Demo functionality for non-logged-in users
  "demo.title": "選擇要回覆的訊息",
  "demo.option1": "銷售開場白（冷聯繫）",
  "demo.option2": "處理「你們價格太高」的探詢",
  "demo.option3": "面試自我介紹（30秒版本）",
  "demo.option4": "郵件回覆",
  "demo.option5": "對「已讀不回」客戶的跟進",
  "demo.option6": "電梯演講（30秒）",
  "demo.runDemo": "運行演示",
  "demo.inputContent": "輸入內容：",
  "demo.scenario": "場景：",
  "demo.target": "目標：",
  "demo.tone": "語氣：",
  "demo.description": "描述：",

  // Showcase Page
  "showcase.title": "溝通展示牆",
  "showcase.subtitle": "探索我們社群分享的AI驅動的啟發性溝通",
  "showcase.userPrefix": "公開溝通由",
  "showcase.backAll": "返回所有展示",
  "showcase.sortBy": "排序方式：",
  "showcase.sort.newest": "最新優先",
  "showcase.sort.oldest": "最早優先",
  "showcase.sort.scenario": "按場景",
  "showcase.sort.target": "按目標",
  "showcase.sort.tone": "按語氣",
  "showcase.filter.scenario": "場景：",
  "showcase.filter.target": "目標：",
  "showcase.filter.tone": "語氣：",
  "showcase.filter.all": "全部",
  "showcase.loading": "正在加載展示牆...",
  "showcase.loadingUser": "正在加載用戶溝通...",
  "showcase.loadingMore": "正在加載更多...",
  "showcase.none.userTitle": "尚無公開溝通",
  "showcase.none.globalTitle": "尚無展示項目",
  "showcase.none.userDesc": "此用戶尚未在展示牆中分享任何溝通。",
  "showcase.none.globalDesc": "成為第一個在展示牆中分享您的AI溝通的人！",
  "showcase.messageDetails": "訊息詳情",
  "showcase.field.date": "日期",
  "showcase.field.scenario": "場景",
  "showcase.field.target": "目標",
  "showcase.field.tone": "語氣",
  "showcase.originalMessage": "原始訊息",
  "showcase.description": "描述",
  "showcase.aiResponse": "AI回覆",

  // Templates
  "templates.saveAsTemplate": "保存為模板",
  "templates.saved": "模板已保存",
  "templates.saveSuccess": "模板保存成功",
  "templates.title": "我的模板",
  "templates.new": "新建模板",
  "templates.loading": "加載中...",
  "templates.none": "未找到模板",
  "templates.name": "名稱",
  "templates.scenario": "場景",
  "templates.target": "目標",
  "templates.tone": "語氣",
  "templates.description": "描述",
  "templates.save": "保存",
  "templates.saving": "保存中...",
  "templates.delete": "刪除模板",
  "templates.deleteConfirm": "刪除這個模板？",
  "templates.deleteFailed": "刪除模板失敗",
  "templates.nameRequired": "* 請輸入模板名稱",
  "templates.deleteSuccess": "模板刪除成功",

  // History Modal additions
  "history.messageDetails": "訊息詳情",
  "history.messageDetailsDesc": "查看和管理訊息詳情，包括原始輸入和AI生成的回覆。",
  "history.field.date": "日期",
  "history.field.scenario": "場景",
  "history.field.target": "目標",
  "history.field.tone": "語氣",
  "history.originalMessage": "原始訊息",
  "history.aiResponse": "AI回覆",
  "history.description": "描述",
  "history.listTitle": "訊息歷史",
  "history.listDesc": "瀏覽、篩選和管理您的對話歷史。點擊任何訊息查看詳情。",
  "history.sortBy": "排序方式：",
  "history.sort.newest": "最新優先",
  "history.sort.oldest": "最早優先",
  "history.sort.scenario": "按場景",
  "history.sort.target": "按目標",
  "history.sort.tone": "按語氣",
  "history.filter.scenario": "場景：",
  "history.filter.target": "目標：",
  "history.filter.tone": "語氣：",
  "history.filter.all": "全部",
  "history.loading": "正在加載歷史...",
  "history.loadingMore": "正在加載更多...",
  "history.none": "未找到訊息",
  "history.showing": "顯示 {current} / {total} 條訊息",
  "history.allLoaded": "所有訊息已加載",
  "history.scrollMore": "向下滾動加載更多",
  "history.loadMoreButton": "加載更多",
  "history.deleteMessage": "刪除訊息",
  "history.deleting": "正在刪除...",
  "history.deleteSuccess": "訊息記錄刪除成功",
  "history.deleteFailed": "訊息記錄刪除失敗，請重試",
  "history.confirmDeleteTitle": "確認刪除",
  "history.confirmDeleteSubtitle": "此操作不可撤銷",
  "history.confirmDeleteDesc": "您確定要刪除此訊息記錄嗎？",
  "history.confirmDeleteAction": "確認刪除",
  "history.shareTitle": "分享到展示牆",
  "history.shareSubtitle": "將此訊息公開",
  "history.sharing": "正在分享...",
  "history.confirmShareAction": "確認分享",
  "history.shareSuccess": "訊息成功分享到展示牆",
  "history.shareFailed": "分享到展示牆失敗，請重試",
  "templates.saveFailed": "模板保存失敗",

  // User Menu
  "userMenu.myAccount": "我的帳戶",
  "userMenu.history": "歷史記錄",
  "userMenu.templates": "我的範本",
  "userMenu.signOut": "登出",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI回覆預覽",
  "hero.preview.scenarioLabel": "場景",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "銷售開場",
  "demo.shortTitle.priceObjection": "價格異議",
  "demo.shortTitle.interviewIntro": "面試介紹",
  "demo.shortTitle.emailReply": "郵件回覆",
  "demo.shortTitle.followUp": "跟進",
  "demo.shortTitle.elevatorPitch": "電梯演講",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "輸入提示",
  "demoTabs.context": "上下文",
  "demoTabs.description": "描述",
  "demoTabs.generate": "生成",
  "demoTabs.aiOutput": "AI輸出",
  "demoTabs.sample": "樣本",
  "demoTabs.streaming": "流式傳輸令牌...",
  "preview.section.scenarioTemplates.title": "場景與模板",
  "preview.section.scenarioTemplates.subtitle": "快速選擇場景或應用已保存的模板。模板預先填寫描述/目標/語氣，讓您直接進入高品質生成。",
  "preview.section.customInputs.title": "自定義輸入",
  "preview.section.customInputs.subtitle": "核心輸入 + 可選描述 + 高級場景/目標/語氣選擇器。自由組合以獲得情境感知的結果。",
  "preview.section.cutReplyTime.title": "回覆時間縮短90%",
  "preview.section.cutReplyTime.subtitle": "比較手動起草與AI協助。並行選項 + 內置翻譯或修改循環。",
  "preview.section.copyShare.title": "一鍵複製和分享",
  "preview.section.copyShare.subtitle": "多個選項排列，統一的頂部操作：複製全部 / 分享 / 按選項複製。翻譯自動附加。",
  "preview.templates.my": "我的模板",
  "preview.templates.new": "新建",
  "preview.manualFlow": "手動流程",
  "preview.aiAssisted": "AI協助",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "規劃結構和語氣",
  "preview.manualFlow.step2": "起草開場 / 刪除並重寫",
  "preview.manualFlow.step3": "調整禮貌和語法",
  "preview.manualFlow.step4": "搜索詞彙 + 驗證翻譯",
  "preview.manualFlow.step5": "粘貼到目標應用",
  "preview.copyAll": "複製全部",
  "preview.share": "分享",
  "preview.enPlusTranslation": "英文 + 翻譯",
  "preview.translationAppendNote": "(*) 複製全部時翻譯自動附加。",
  "preview.field.scenario": "場景",
  "preview.field.target": "目標",
  "preview.field.tone": "語氣",
  "preview.auto": "自動",
  "preview.step.pasteOrTemplate": "粘貼請求或選擇模板",
  "preview.step.optionalDescription": "(可選) 添加描述/場景",
  "preview.step.pickOption": "選擇生成的選項之一",
  "preview.step.copyShareTranslate": "一鍵複製/分享/翻譯",
  "preview.time.manual": "5–8分鐘",
  "preview.time.ai": "30–40秒"
};